import styled from 'styled-components';
import { MenuItemContainer } from '../MenuItem/styles';

const MenuItemsContainer = styled.ul`
  margin-right: auto;
  padding-left: 0;
  margin-bottom: 0;
  ${MenuItemContainer}:last-of-type {
    .menu-item--parent-link {
      font-weight: 400;
    }
  }

  ${({ isMobileMenuOpened }) => {
    if (isMobileMenuOpened) {
      return `
          max-height: 3000px !important;
          opacity: 1 !important;
          overflow: hidden;
        `;
    }
  }}

  @media (max-width: 1240px) {
    display: ${({ isMobileMenuOpened }) => (isMobileMenuOpened ? 'block' : 'none')};
    padding: 0 30px;
    position: absolute;
    left: 0;
    top: 91px;
    background: white;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53),
      opacity 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);

    .website-header--menu-item--opened .simple-menu,
    .website-header--menu-item--opened .mega-menu {
      max-height: 3000px !important;
      visibility: visible;
      opacity: 1;
      height: auto;
      overflow: visible;
      transition: max-height 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53),
        opacity 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
      margin-top: 0 !important;
      margin-left: 0;
      max-width: 100%;
    }

    .simple-menu,
    .mega-menu {
      max-height: 0;
      opacity: 0;
      visibility: hidden;

      .mega-menu-item,
      .simple-menu-item a {
        width: max-content;
      }
    }
  }
`;

export { MenuItemsContainer };
